// P7: a rest day in the stall ("Repos au box") is said explicitly on its step:
// the API sends `is_rest` in every step payload. Pure, no '@/' import.
//
// It is never inferred from a step without gaits where the step is read
// strictly (Record page, recording screen): empty steps exist in prod and are
// not rest days. Only the P9 card keeps "no walk, trot nor canter = rest", and
// only for a payload that does not carry the flag at all (program-days.js).

import { timedRows } from './gait-offset.js'

// Whether the payload carries the flag at all: an old cached payload does not.
export const hasRestFlag = (step) => step?.is_rest !== undefined && step?.is_rest !== null

// The flag as the API may send it: a boolean, 0/1, or their string forms.
export const readRestFlag = (value) => value === true || value === 1 || value === '1' || value === 'true'

// A rest day only when the step says so.
export const isFlaggedRest = (step) => hasRestFlag(step) && readRestFlag(step.is_rest)

// The recording screen says "Rest day" when today's step is flagged rest and
// has nothing to count down. A rest step that still carries gaits (only through
// the API: the switch clears them) keeps its guidance, as the Record page line does.
export const showsRestDay = (step) => isFlaggedRest(step) && timedRows(step?.gaits).length === 0

// Turning a step into a rest day clears its gaits: ask first, but only when
// there is something to lose.
export const restSwitchNeedsConfirm = (step) => Array.isArray(step?.gaits) && step.gaits.length > 0

// What the step card sends when the switch changes. On, the gaits go with it;
// off, the step is left empty for the gaits to be added again (no row made up).
export const restSwitchPayload = (isRest) => (isRest ? { is_rest: true, gaits: [] } : { is_rest: false })
